<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-card>
          <v-row>
            <v-col cols="12">
              <v-sheet width="160" rounded="sm" class="pl-2">
                <v-list-item
                  class="py-0 px-0"
                  @click="$router.push('/manageCard')"
                >
                  <v-list-item-icon class="mr-0">
                    <v-icon small> mdi-chevron-left</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle> Your Card</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-sheet>
            </v-col>
          </v-row>
          <v-card-title>
            <div class="text-h5">Your Card Design</div>
          </v-card-title>

          <v-card-text>
            <SendRequestDialog
              requestType="CUSTOM_CARD_DESIGN"
              :showDialog="sendRequestDialog"
              @canceled="sendRequestDialog = false"
            />

            <!-- <v-btn dark text @click="sendRequestDialog = true" class="mr-10">Request a Custom Design</v-btn> -->

            <v-tabs v-model="tab" align-with-title color="primary">
              <v-tab
                v-for="item in tabItemTitles"
                :key="item"
                class="text-capitalize ml-0"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
            <v-divider></v-divider>

            <v-row>
              <v-col cols="12">
                <BusinessCardEditor
                  :tab="tab"
                  :bus="bus"
                  ref="cardEditor"
                  @save="onSave"
                />
              </v-col>
              <v-col cols="4"> </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Vue from "vue";
import BusinessCardEditor from "./BusinessCardEditor";
import SendRequestDialog from "@/components/SendRequestDialog";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AddEditBusinessCardDialog",
  components: {
    BusinessCardEditor,
    SendRequestDialog,
  },
  data() {
    return {
      sendRequestDialog: false,
      dialog: false,
      tab: 0,
      tabItemTitles: ["Card Front", "Card Back", "Background"],
      bus: new Vue(),
    };
  },

  computed: mapGetters(["businessProfile"]),
  methods: {
    ...mapActions(["updateBusinessProfileDetails"]),
    initDialog() {
      this.tab = 0;
      this.bus.$emit("initEditor");
      this.dialog = true;
    },
    async onSave() {
      console.log("call3e");
      await this.$refs.cardEditor.onSave();
      if (this.tab == 2) {
        this.dialog = false;
        //Start: Update isBusinessCardDesignAdded if required
        if (this.businessProfile.isBusinessCardDesignAdded != true) {
          this.updateBusinessProfileDetails({
            isBusinessCardDesignAdded: true,
          });
        }
        //End: Update isBusinessCardDesignAdded if required
      } else {
        this.tab = this.tab + 1;
      }
    },
  },
};
</script>
<style scoped>
.v-list-item--link:hover {
  border-radius: 8px 8px 8px 8px !important;
}
.v-list-item--link:before {
  border-radius: 8px 8px 8px 8px !important;
}
.theme--dark.v-list-item--active::before {
  opacity: 0;
}

.parent {
  position: relative;
}

.fixed {
  position: fixed;
  /* right: 3%; */
  bottom: 3%;
}

.btn {
  top: 28%;
  right: 6.5%;
}
</style>
